import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone'


  function DropZone(props) {
    const onDrop = useCallback(acceptedFiles => {
      // Do something with the files

      props.handleFileError(null)

      let file = acceptedFiles[0];

      const MAXSIZE = 4
      if (file.size > MAXSIZE * 1024 * 1024 ) {
        props.handleFileError("Arxiu massa gran màxim " + MAXSIZE + "MB")
        file = undefined
        props.onChange() // buidem file al no ser correcte
      }

      if (file) {

        //console.log("FT",file.type);
        if (!/^image\/png/.test(file.type) && !/^image\/jpeg/.test(file.type)) {
          file = undefined
          props.onChange() // buidem file al no ser correcte
          props.handleFileError("Tipus d'arxiu no vàlid. S'accepten imatges JPG o PNG.")
          return false
        }

        const reader = new FileReader()
        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')
        reader.onload = () => {
          // Do whatever you want with the file contents
          const fileContent = reader.result
          //console.log("BIN", fileContent)

          props.onChange({file: file, fileContent: fileContent})

          //console.log(acceptedFiles[0].name) // size type
        }
        reader.readAsDataURL(file)
      }

    }, [])
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

    return (
      <div className={ 'col ' + props.col}>
        <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id={props.id + '_CONTAINER'}>
          <div className="t-Form-labelContainer">
            <label htmlFor={props.id} id={props.id + '_LABEL'} 
              className="t-Form-label">{props.label} <small>{props.labelSmall}{ props.obligatori ? (<sup>*</sup>) : "" }</small></label>
          </div>
          <div className="t-Form-inputContainer">
            <div className="t-Form-itemWrapper">
              <div {...getRootProps()} style={{ width: '100%' }}>
                <input {...getInputProps()} />
                {isDragActive && <p>Drop the files here ...</p>}
                {!isDragActive && (<div className="dropZone"> {props.file?.file ? props.file.file.name : props.labelDrop}</div>)}
              </div>
            </div>
            <span id={props.id + '_ERROR'} className="a-Form-error">{props.error}</span>
          </div>
        </div>
      </div>)
  }

export default DropZone